import { useState } from "react";
import logger from "../services/Logger";
import { API_VERSION, SERVER_URL } from "../consts";

import { useAuth } from "../services/authContext";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setAuthenticated, authenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
    const response = await fetch(`${SERVER_URL}${API_VERSION}/users/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
      credentials: "include",
    });
    await response.json();
    if (response.ok) {
      logger.info("User is authenticated");
      if (!authenticated) setAuthenticated(true);
      navigate("/"); // Navigate to home screen after successful login
    } else {
      logger.info("Login page- User is not authenticated");
      if (authenticated) setAuthenticated(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <>
      <div>
        <h2>Login</h2>
        <input placeholder="Username" onKeyDown={(e) => handleKeyDown(e)} onChange={(e) => setUsername(e.target.value)} />
        <input type="password" placeholder="Password" onKeyDown={(e) => handleKeyDown(e)} onChange={(e) => setPassword(e.target.value)} />
        <button onClick={handleLogin}>Login</button>
      </div>
    </>
  );
};

export default Login;
